module.exports = __webpack_public_path__ + "static/media/image_placeholder.4ffb9fca.png";